import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxWrapper } from './styles';
import { SvgCheck, SvgMinus } from '../../svg';

const Checkbox = ({
  id,
  testid,
  value,
  name,
  onChange,
  onBlur,
  onKeyDown,
  style,
  inline,
  checked,
  indeterminate,
  disabled,
  label,
  radio,
  error,
}) => {
  return (
    <CheckboxWrapper
      radio={radio}
      inline={inline}
      style={style}
      disabled={disabled}
      role={radio ? 'radio' : 'checkbox'}
      aria-checked={checked}
      error={error}
    >
      <input
        data-testid={testid}
        type={radio ? 'radio' : 'checkbox'}
        id={id || name}
        name={name}
        checked={checked}
        indeterminate={indeterminate ? 1 : 0}
        value={value}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      />
      <div className="checkmark">
        {radio ? <div className="radio-check" /> : indeterminate ? <SvgMinus /> : <SvgCheck />}
      </div>
      <label htmlFor={id || name}>{label}</label>
    </CheckboxWrapper>
  );
};

Checkbox.propTypes = {
  radio: PropTypes.bool,
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  disabled: PropTypes.bool,
  inline: PropTypes.bool,
  value: PropTypes.string,
  id: PropTypes.string,
  testid: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  style: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

Checkbox.defaultProps = {
  onChange: () => {},
};

export default React.memo(Checkbox);
